// Группировка механик вопросов для селектов и списка.
// Ожидается список, уже отсортированный бэкендом: раздел (музыка и любые, затем кино), группа (без группы — в конце), порядок, название.

export const NO_GROUP_LABEL = 'Без группы'

/**
 * Разбивает механики на группы в порядке первого появления.
 * Группа определяется парой «раздел (кино / музыка и любые) + название», механики без группы собираются в «Без группы».
 * @param {Array<{content_kind?: string, group?: string|null}>} mechanics
 * @returns {Array<{key: string, label: string, mechanics: Array}>}
 */
export const groupMechanics = mechanics => {
  const groups = []
  const groupsByKey = {}
  ;(mechanics || []).forEach(mechanic => {
    const groupName = mechanic.group ? String(mechanic.group).trim() : ''
    // «Любые» механики делят группы с музыкальными (бэкенд сортирует их вместе)
    const section = mechanic.content_kind === 'movies' ? 'movies' : 'music'
    const key = `${section}|${groupName}`
    if (!groupsByKey[key]) {
      groupsByKey[key] = { key, label: groupName || NO_GROUP_LABEL, mechanics: [] }
      groups.push(groupsByKey[key])
    }
    groupsByKey[key].mechanics.push(mechanic)
  })

  return groups
}

/**
 * Опции для b-form-select: нативные группы { label, options } (optgroup).
 * @param {Array} mechanics
 * @param {Function} toOption mechanic => { value, text }
 */
export const toSelectGroups = (mechanics, toOption) => groupMechanics(mechanics)
  .map(group => ({ label: group.label, options: group.mechanics.map(toOption) }))

/**
 * Плоский список для vue-select: перед каждой группой — несбираемая строка-заголовок.
 * Заголовок хранит название в `name`, чтобы работал `label="name"`.
 */
export const toVueSelectOptions = mechanics => {
  const options = []
  groupMechanics(mechanics).forEach(group => {
    options.push({ id: `group:${group.key}`, name: group.label, isGroupHeader: true })
    group.mechanics.forEach(mechanic => options.push(mechanic))
  })

  return options
}

// Для пропа selectable у vue-select: заголовки группы выбрать нельзя
export const isMechanicSelectable = option => !(option && option.isGroupHeader)

// Названия существующих групп (для подсказок в форме механики)
export const existingGroupNames = mechanics => Array.from(new Set(
  (mechanics || []).map(mechanic => (mechanic.group ? String(mechanic.group).trim() : '')).filter(Boolean),
))
